// $('.scrollIn').each(function(){
//   let $item = $(this);
//   $(window).on('scroll', function(){
//     let top = $item.offset().top; // ターゲットの位置取得
//     let position = top - $(window).height();  // イベントを発火させたい位置
//     if($(window).scrollTop() > position){
//       $item.addClass('isShow');
//     }
//   });
// });
jQuery(function ($) {
	function scrollChk(){
		var scroll = $(window).scrollTop();
		var windowHeight = $(window).height();

			jQuery('.scrollIn').not('.active').each(function(){
					var pos = $(this).offset().top;

					if (scroll > pos - windowHeight){
							$(this).addClass("active");
					}
			});
	}
	$(window).scroll(function (){
			scrollChk();
	});
	$('body').on('touchmove', function() {
			scrollChk();
	});
});
